// 261015 P4c-2b (D12) — phần VẼ của "nhịp hấp dẫn dự kiến" ở ④: ô của cột + khối trong thẻ "Chốt dàn tập". Quyết định hiển thị nằm ở `episodeAppealView.ts` (thuần, có jest); file này chỉ ráp antd.
import React from 'react';
import { Button, Space, Tag, Tooltip, Typography } from 'antd';
import type { AppealCell, AppealPlanBlock } from './episodeAppealView';

const { Text } = Typography;

/** Ô của một tập: thẻ màu theo loại + chữ ý (tooltip: trích nguồn / ghi chú); CHƯA CHỈ RA / CHƯA KIỂM = chữ xám. Không có tông đỏ — nhãn này không phải lỗi. */
export const AppealCellView: React.FC<{ cell: AppealCell }> = ({ cell }) => {
  if (cell.kind === 'none') return <Text type="secondary" style={{ fontSize: 13 }}>—</Text>;
  return (
    <Space direction="vertical" size={2} style={{ width: '100%' }} data-testid={`appeal-cell-${cell.kind}`}>
      {cell.chips.map((c) => (
        <Tooltip key={c.claimId} title={<div>{c.tooltip.map((l, i) => <div key={i}>{l}</div>)}</div>}>
          <span style={{ opacity: cell.kind === 'unknown' ? 0.6 : 1 }}>
            <Tag color={c.color} style={{ marginRight: 4 }}>{c.label}</Tag>
            <Text style={{ fontSize: 13 }}>{c.text}</Text>
          </span>
        </Tooltip>
      ))}
      {cell.text && <Text type="secondary" style={{ fontSize: 13 }}>{cell.text}</Text>}
    </Space>
  );
};

/** Dòng phủ + mọi đoạn tập liền chưa chỉ ra nhịp + câu "dự kiến" + nút "Hỏi trợ lý". Không chặn nút Chốt; mọi dòng cùng một kiểu (độ dài chỉ là số quan sát, không mức độ). */
export const AppealPlanSummary: React.FC<{ block: AppealPlanBlock; onAsk: () => void; askDisabled?: boolean }> = ({ block, onAsk, askDisabled }) => (
  <div data-testid="appeal-plan-summary" style={{ marginTop: 4 }}>
    <Text strong style={{ fontSize: 13 }}>{block.coverageLine}</Text>
    {block.runLines.length > 0 && (
      <div style={{ maxHeight: 160, overflowY: 'auto' }}>
        {block.runLines.map((l) => <div key={l.key}><Text type="secondary" style={{ fontSize: 13 }}>{l.text}</Text></div>)}
      </div>
    )}
    <div><Text type="secondary" style={{ fontSize: 13 }}>{block.note}</Text></div>
    {block.canAsk && (
      <Button size="small" type="link" style={{ padding: 0 }} disabled={askDisabled} onClick={onAsk}>Hỏi trợ lý</Button>
    )}
  </div>
);
